import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DocumentsComponent } from "./documents.component";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "../freightconfirmation/app.sharemodule";
import { RouterModule } from "@angular/router";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../theme/home/translateConfig.service";
import { SafePipe } from "../_Pipes/safe.pipe";
// For Translator

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    RouterModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [TranslateConfigService],
  declarations: [DocumentsComponent, SafePipe],
  exports: [DocumentsComponent, SafePipe],
})
export class DocumentsharedModule { }
